import {
	call, put, takeEvery,
} from "redux-saga/effects";
import {
	ActionsCategory,
	failureCategory,
	loadCategorySuccess,
	loadGetCategory,
} from "./actions";
import Env from "../../../consts/env";

function* loadDataCategory() {

	try {

		yield put(loadGetCategory());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getProductCategories`;
		const headers = { ...Env.HEADERS };
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		const dataReview = yield response.json();

		if (response.status !== 200) {

			yield put(failureCategory(yield response.statusText));

		} else {

			yield put(loadCategorySuccess(yield dataReview));

		}

	} catch (err) {

		yield put(failureCategory(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsCategory.GET_CATEGORY, loadDataCategory);

}
